export const CREATE_SYSTEM_MESSAGE = gql`
  mutation CreateSystemMessage($input: CreateSystemMessageInput!) {
    createSystemMessage(input: $input) {
      startAt
      endAt
      title
      body
    }
  }
`

export const GET_SYSTEM_MESSAGES = gql`
  query GetSystemMessages {
    systemMessages {
      title
      startAt
      endAt
      id
      body
      updatedAt
    }
  }
`

export const UPDATE_SYSTEM_MESSAGE = gql`
  mutation UpdateSystemMessage(
    $id: String!
    $input: UpdateSystemMessageInput!
  ) {
    updateSystemMessage(id: $id, input: $input) {
      id
      startAt
      endAt
      title
      body
      updatedAt
      createdAt
    }
  }
`

export const DELETE_SYSTEM_MESSAGE = gql`
  mutation DeleteSystemMessage($id: String!) {
    deleteSystemMessage(id: $id) {
      id
    }
  }
`

export const GET_RESOURCE_LINKS = gql`
  query GetResourceLinks {
    resourceLinks {
      id
      title
      url
    }
  }
`

export const CREATE_RESOURCE_LINK = gql`
  mutation CreateResourceLink($input: CreateResourceLinkInput!) {
    createResourceLink(input: $input) {
      title
      url
    }
  }
`

export const UPDATE_RESOURCE_LINK = gql`
  mutation UpdateResourceLink($id: String!, $input: UpdateResourceLinkInput!) {
    updateResourceLink(id: $id, input: $input) {
      id
      title
      url
    }
  }
`
export const DELETE_RESOURCE_LINK = gql`
  mutation DeleteResourceLink($id: String!) {
    deleteResourceLink(id: $id) {
      id
    }
  }
`
